module.exports = __webpack_public_path__ + "assets/successNote1Speck1-abc863.svg";